import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Checkbox, ListItemText, Input } from '@material-ui/core';
import Select from '@mui/material/Select';

function CategoryFilter({ categories, selectedCategories, onCategoryChange, label, categoryFilterClass }) {
    const baseClass = "w-auto ms-auto mt-auto w-res-100";
    const [open, setOpen] = useState(false);

    return (
        <div className={baseClass}>
            <FormControl className={`me-2 category-list-dropdown ${categoryFilterClass || ''}`}>
                <InputLabel size="small" focused={false} id="demo-multiple-checkbox-label" >Catalog Filter</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={selectedCategories}
                    onChange={(e) => {
                        const nextSelected = e.target.value;
                        onCategoryChange(nextSelected);
                        if ((nextSelected || []).length === 0) setOpen(false);
                    }}
                    input={<Input className="category-filter" label={'Catalog Filter'} />}
                    renderValue={(selected) => {
                        const values = (selected || []);
                        if (values.length === 0) return null;
                        return values.map(val => categories.find(c => c.value === val)?.templateNameWithCount).join(', ');
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 400,
                                width: 240,
                            },
                        },
                    }}
                >
                    {(categories || []).map((category) => (
                        <MenuItem key={category.value} value={category.value}>
                            <Checkbox checked={selectedCategories.includes(category.value)} />
                            <ListItemText primary={category.templateNameWithCount} primaryTypographyProps={{ className: "category-filter-text" }} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div >
    );
}

export default CategoryFilter;